import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/instrumentos/encuestas'

const getEncuestas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const getEncuestaPorId = async (id = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/${id}/`)
  return response.data
}

const crearEncuesta = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarEncuesta = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarEncuesta = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getEncuestas,
  getEncuestaPorId,
  crearEncuesta,
  eliminarEncuesta,
  actualizarEncuesta,
}